import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CakeItEasyWebUiModule } from '@cakeiteasy/web-ui';
import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgBusyModule } from 'ng-busy';
import { UiSwitchModule } from 'ngx-ui-switch';

import { ChoosePaymentPersonTypeComponent } from './components/choose-payment-person-type/choose-payment-person-type.component';
import { ChoosePaymentTypeComponent } from './components/choose-payment-type/choose-payment-type.component';
import { KlarnaPaymentComponent } from './components/klarna-payment/klarna-payment.component';
import { BamboraPaymentComponent } from './components/bambora-payment/bambora-payment.component';
import { DinteroPaymentComponent } from './components/dintero-payment/dintero-payment.component';
import { MobileDinteroPaymentComponent } from './components/mobile-dintero-payment/mobile-dintero-payment.component';
import { VippsPaymentComponent } from './components/vipps-payment/vipps-payment.component';
import { PayInStorePaymentComponent } from './components/pay-in-store-payment/pay-in-store-payment.component';
import { PayInStorePaymentBComponent } from './components/pay-in-store-payment-b/pay-in-store-payment-b.component';
import { ZeroPaymentComponent } from './components/zero-payment/zero-payment.component';
import { ZeroPaymentBComponent } from './components/zero-payment-b/zero-payment-b.component';
import { PaymentContactInfoComponent } from './components/payment-contact-info/payment-contact-info.component';
import { PaymentContactInfoBComponent } from './components/payment-contact-info-b/payment-contact-info-b.component';
import { OrderReferenceInputComponent } from './components/order-reference-input/order-reference-input.component';
import { GiftCardPaymentComponent } from './components/gift-card-payment/gift-card-payment.component';
import { GiftCardPaymentBComponent } from './components/gift-card-payment-b/gift-card-payment-b.component';

import { BamboraCheckoutService } from './services/bambora-checkout.service';
import { DinteroCheckoutService } from './services/dintero-checkout.service';
import { PaymentStorageService } from './services/payment-storage.service';
import { KlarnaCheckoutService } from './services/klarna-checkout.service';
// TODO get rid of afterContentInit
import { AfterContentInitDirective } from './directives/ng-after-content-init.directive';
import { PaymentApiService } from '../api-services/services/payment-api.service';
import { CompanyApiService } from '../api-services/services/company-api.service';
import { UserInvoiceInfoComponent } from './components/user-invoice-info/user-invoice-info.component';
import { InvoicePaymentComponent } from './components/invoice-payment/invoice-payment.component';
import { InvoicePaymentBComponent } from './components/invoice-payment-b/invoice-payment-b.component';
import { CompanySearcherComponent } from './components/company-searcher/company-searcher.component';
import { VippsBtnComponent } from './components/choose-payment-type/vipps-btn/vipps-btn.component';
import { ExclusiveBamboraPaymentComponent } from './components/exclusive-bambora-payment/exclusive-bambora-payment.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';

const COMPONENTS = [
  ChoosePaymentPersonTypeComponent,
  ChoosePaymentTypeComponent,
  TermsAndConditionsComponent,
  UserInvoiceInfoComponent,
  InvoicePaymentComponent,
  InvoicePaymentBComponent,
  CompanySearcherComponent,
  KlarnaPaymentComponent,
  BamboraPaymentComponent,
  DinteroPaymentComponent,
  MobileDinteroPaymentComponent,
  ExclusiveBamboraPaymentComponent,
  PayInStorePaymentComponent,
  PayInStorePaymentBComponent,
  ZeroPaymentComponent,
  ZeroPaymentBComponent,
  PaymentContactInfoComponent,
  PaymentContactInfoBComponent,
  OrderReferenceInputComponent,
  VippsPaymentComponent,
  GiftCardPaymentComponent,
  GiftCardPaymentBComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CakeItEasyWebUiModule,
    NgCakeItEasyUtilsModule,
    TranslateModule.forChild(),
    NgbModule,
    NgBusyModule,
    UiSwitchModule,
  ],
  exports: [
    ...COMPONENTS,
  ],
  declarations: [
    ...COMPONENTS,

    VippsBtnComponent,
    AfterContentInitDirective,

  ],
  providers: [
    CompanyApiService,
    PaymentApiService,
    BamboraCheckoutService,
    DinteroCheckoutService,
    PaymentStorageService,
    KlarnaCheckoutService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PaymentModule {
  static forRoot(): ModuleWithProviders<PaymentModule> {
    return {
      ngModule: PaymentModule
    };
  }
}
